// src/pages/usa/OregonSilverFalls.js
import "../../App.css";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import BackOnly from "../../components/BackOnly";
import ContactPopup from "../../components/ContactPopup";
import AffiliateBooking from "../../components/affiliate/AffiliateBooking";   // ⭐ REQUIRED
import AffiliateExpedia from "../../components/affiliate/AffiliateExpedia";   // ⭐ REQUIRED
import AffiliateTrip from "../../components/affiliate/AffiliateTrip";   // ⭐ REQUIRED
import React, { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";   // ⭐ REQUIRED

// ⭐ STRICT COMMAND: Oregon Silver Falls ALWAYS goes back to Oregon map
export const backRoute = "/map/oregon";

export default function OregonSilverFalls() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  // ⭐ Send strict back command to BackOnly (NO LOOPS)
  useEffect(() => {
    if (!window.__oregonSilverFallsBackRouteSet) {
      window.__oregonSilverFallsBackRouteSet = true;
      navigate(".", { replace: true, state: { backRoute } });
    }
  }, [navigate]);

  return (
    <>
      <Header />

      <div className="visited-back-wrapper">
        <BackOnly />
      </div>

      <div className="page-container" style={{ padding: "12px" }}>
        <h1>Oregon / Silver Falls State Park</h1>

        <section className="travel-review">
          {/* LEFT COLUMN */}
          <div className="travel-text">
            <h2>🏞️ Oregon / Silver Falls State Park</h2>


            <p>
              This day started early, the rain was still pouring, but I was determined to explore Silver Falls State
               Park. I had heard so much about the Trail of Ten Falls, and I wanted to experience it for myself. 
               The park is located about an hour south of Portland, and it’s a must‑visit for anyone who loves 
               waterfalls and nature.
            </p>

            

            {/* GETTING THERE */}
            <h3>🚗 Getting There</h3>

            <p>
              Getting to Oregon depends on where you are coming from and what kind of trip you are
              planning. Some people drive in from neighboring states, especially along the coast
              road, which is full of stunning views and hidden spots.
              </p>

            <p>
              I flew into Portland International Airport (PDX), rented a car through Dollar, and
              stayed at the Best Western Plus Portland Airport Hotel and Suites. It was convenient,
              close to the airport, easy to get in and out, and a great base to start exploring.
              Whether you are heading for waterfalls, the coast, or the mountains, having a car
              makes all the difference in Oregon.    <strong>Driving from Portland to Silver Falls State Park: </strong>
              I started at the Best Western Plus near the Portland Airport and took the following
              roads in order: I‑205 South → OR‑213 South → Valley View Road → Evans Valley Road →
              Madrona Heights Road → Quail Road → Forest Ridge Road → OR‑214 South. This final
              stretch on OR‑214 takes you directly into Silver Falls State Park. It’s a scenic
              drive through farmland, rolling hills, and forested backroads. 
            </p>

            {/* PERSONAL OBSERVATION */}
            <h3>🌟 My Personal Observation</h3>

            
            {/* SILVER FALLS */}
            <h3>💧 Silver Falls State Park</h3>

           <p>
  Silver Falls State Park is another must‑do. The trail loop that takes you to all
  the waterfalls in this park is amazing. I went early to have time to walk and
  enjoy the nature and waterfalls without worrying about nightfall.
</p>

<p>
  This time I was not fully prepared, and I learned from my mistakes. My plan is to
  visit this park again, and for my next visit I will bring extra clothes to change
  after the hike. We walked behind some of the waterfalls, and it was also raining
  constantly. The park features ten waterfalls along the Trail of Ten Falls, including
  South Falls, Lower South Falls, and Double Falls — the tallest at 178 feet. You can
  walk behind several of them, like South Falls and North Falls, which makes the
  experience unforgettable.
</p>

<p>
  On this visit, I walked about 13 miles in roughly 7 hours, taking my time to capture
  photos and videos along the way. Silver Falls State Park is located in
  <strong>Marion County, Oregon</strong>.
</p>


            <ul>
              <li>
                <div className="place-block">
                  <strong>Silver Falls State Park:</strong>
                  <br />
                  <a
                    href="https://www.google.com/maps?q=44.87785642075388,-122.65612288003047"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Silver Falls State Park — View on Google Maps
                  </a>
                </div>
              </li>
            </ul>

            {/* HIDDEN GEMS */}
           <h3>🌲 Hidden Gem</h3>
<p>
  If you have extra time in the area, one hidden gem worth mentioning is 
  <strong> Opal Pool Falls </strong>, located in the Opal Creek Wilderness. 
  It’s about <strong>1.5 hours from Silver Falls State Park</strong> Is in my list
  for my next visit, but from what I’ve heard and seen, it’s a stunning waterfall with a beautiful 
  swimming hole at the base. The hike to Opal Pool Falls is about 4 miles round trip and takes you 
  through an old-growth forest, past several smaller waterfalls, and finally 
  to the main attraction — a 50-foot waterfall cascading into a crystal-clear pool. "All this
  information is based on my research and the experiences of other travelers, as I haven’t had the chance 
  to visit Opal Pool Falls yet. It’s definitely on my list for the next trip to Oregon!"
 
</p>



<p>
   <a
                    href="https://www.google.com/maps?q=44.83422722954847, -122.19911544417535"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Opal Pool Falls — View on Google Maps
                  </a>
</p>

<p>
  Keep in mind that this area has had closures in the past due to wildfire 
  damage, so it’s always a good idea to check the latest conditions before 
  visiting. When open, it’s absolutely worth the trip — quiet, scenic, and 
  a true hidden gem near the Silver Falls and Salem region.
</p>


            

            <h3>🛏️ Places to Stay Near Silver Falls State Park</h3>

<p>
  There are no hotels inside Silver Falls State Park, but several nearby towns offer
  great options. The closest places to stay are in Silverton, Sublimity, and Stayton,
  all within 18–25 minutes of the park. Salem is the nearest major city, located
  about 35–40 minutes away.
</p>

<ul>

  {/* ⭐ CLOSEST OPTIONS — SILVERTON (20–25 minutes) */}
  <li>
    <div className="place-block">
      <strong>Oregon Garden Resort (Silverton):</strong> The closest full‑service
      hotel to Silver Falls, located about 20 minutes from the park. Beautiful
      gardens, quiet atmosphere, and great amenities.
      <em> Available on Expedia & Booking.com.</em>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Silverton Inn &amp; Suites:</strong> Small boutique hotel in downtown
      Silverton, about 22 minutes from the park. Cozy and walkable.
      <em> Available on Booking.com.</em>
    </div>
  </li>

  {/* ⭐ VERY CLOSE — SUBLIMITY & STAYTON (18–22 minutes) */}
  <li>
    <div className="place-block">
      <strong>Rodeway Inn &amp; Suites Sublimity:</strong> One of the closest hotels
      to Silver Falls, only about 18 minutes away. Simple but extremely convenient.
      <em> Available on Expedia & Booking.com.</em>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Best Western Stayton Inn:</strong> Clean, reliable, and about
      20 minutes from the park. Great option for early morning hikes.
      <em> Available on Expedia & Booking.com.</em>
    </div>
  </li>

  {/* ⭐ SALEM — NEAREST MAJOR CITY (35–40 minutes) */}
  <li>
    <div className="place-block">
      <strong>The Grand Hotel in Salem:</strong> Upscale hotel in downtown Salem,
      perfect if you want comfort and amenities. About 35–40 minutes from the park.
      <em> Available on Expedia & Booking.com.</em>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Hampton Inn &amp; Suites Salem:</strong> One of the best‑rated hotels
      in the area. Clean, modern, and reliable.
      <em> Available on Expedia & Booking.com.</em>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Best Western Plus Mill Creek Inn (Salem):</strong> Great value with
      large rooms and easy access to the highway toward Silver Falls.
      <em> Available on Expedia & Booking.com.</em>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Holman Riverfront Park Hotel Salem:</strong> Modern boutique hotel near
      the riverfront with stylish rooms and great dining nearby.
      <em> Available on Expedia & Booking.com.</em>
    </div>
  </li>

</ul>

            {/* AFFILIATE BLOCK */}
           <h3>If you are looking for a place to stay, you can check prices, date and time here.</h3>
                       <div className="affiliate-block">
                         <AffiliateExpedia />
                         <AffiliateBooking />
                         <AffiliateTrip />
                       </div>

            {/* VIDEOS */}
            <h3>🎥 My Travel Videos</h3>

            <p>
              I took these videos from the Columbia River Highway, Oregon Coast, and Silver Falls
              State Park. Set the YouTube video quality to high resolution — I hope you enjoy them.
            </p>

            <p>
              <a
                href="https://youtu.be/sKY4QGH-_dc?si=3TuxLtHJJ1lxwWIB"
                target="_blank"
                rel="noopener noreferrer"
              >
                Columbia River Highway
              </a>
              <br />
              <a
                href="https://youtu.be/gnRiwn0G5M0?si=Pe6mMswPuAE0DvOq"
                target="_blank"
                rel="noopener noreferrer"
              >
                Vista House at Crown Point
              </a>
              <br />
              <a
                href="https://youtu.be/RfD-5Sn4mkU?si=JqfA66NOIjw-Vn_E"
                target="_blank"
                rel="noopener noreferrer"
              >
                Heceta Lighthouse
              </a>
              <br />
              <a
                href="https://youtu.be/eBihBb-C72Q?si=5d8e9BAcBVIzR9_E"
                target="_blank"
                rel="noopener noreferrer"
              >
                            Tunnel Beach
              </a>
              <br />
              <a
                href="https://youtu.be/dtBJI2IkvzQ?si=Nc3FDkqjuILq88Zn"
                target="_blank"
                rel="noopener noreferrer"
              >
                Yaquina Lighthouse
              </a>
              <br />
               <a
                href="https://youtu.be/gnRiwn0G5M0?si=eFoVNkSpctkuaDlI"
                target="_blank"
                rel="noopener noreferrer"
              >
                Vista House at Crown Point
              </a>
              <br />
              <a
                href="https://youtu.be/9VtL3hw9HSQ?si=gNw1aZHo-5ACv47y"
                target="_blank"
                rel="noopener noreferrer"
              >
                Silver Falls State Park
              </a>
            </p>
          </div>

          {/* RIGHT COLUMN */}
          <div className="travel-image-column">
            <a
              href="https://youtu.be/9VtL3hw9HSQ?si=LNTJ6VfaFVYE4Iq-"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/oregon/sfs.jpg"
                alt="Silver Falls State Park Video"
              />
            </a>
            

       

            <img src="/images/usa/oregon/sf1.jpg" alt="Silver Falls State Park" />
            <img src="/images/usa/oregon/sf2.jpg" alt="Silver Falls State Park" />
            <img src="/images/usa/oregon/sf3.jpg" alt="Silver Falls State Park" />
            <img src="/images/usa/oregon/sf4.jpg" alt="Silver Falls State Park" />
            <img src="/images/usa/oregon/sfs.jpg" alt="Silver Falls State Park" />
            <img src="/images/usa/oregon/ss3.jpg" alt="Silver Falls State Park" />
            <img src="/images/usa/oregon/ss5.jpg" alt="Silver Falls State Park" />
            <img src="/images/usa/oregon/ss6.jpg" alt="Silver Falls State Park" />
            <img src="/images/usa/oregon/ss7.jpg" alt="Silver Falls State Park" />
            <img src="/images/usa/oregon/ss8.jpg" alt="Silver Falls State Park" />
            <img src="/images/usa/oregon/ss9.jpg" alt="Silver Falls State Park" />
            <img src="/images/usa/oregon/ss12.jpg" alt="Silver Falls State Park" />
            <img src="/images/usa/oregon/ss13.jpg" alt="Silver Falls State Park" />
            <img src="/images/usa/oregon/ss20.jpg" alt="Silver Falls State Park" />
            <img src="/images/usa/oregon/ss21.jpg" alt="Silver Falls State Park" />

           
          </div>
        </section>
      </div>

      {/* EMAIL BUTTON */}
      <div className="email-wrapper">
        <button className="email-link" onClick={() => setOpen(true)}>
          contact@thefindingspot.com
        </button>
      </div>

      {/* POPUP */}
      <ContactPopup isOpen={open} onClose={() => setOpen(false)} />

      <Footer />
    </>
  );
}
